// @flow
import map from 'ramda/es/map';

import type { Params, AverageMarks } from 'app/dataTypes/AverageMarks.types';
import toFixedValue from 'app/common/lib/toFixedValue';

import type { Request } from '../../../index';


const dateFormatApi: 'YYYY-MM-DD' = 'YYYY-MM-DD';

type ParamsApi = {
  klass_id: number,
  student_id: number,
  date: string,
}

type ResultApi = {
  [discipline_id: string]: number,
  result: 'success',
}

export const convertParams = (params: Params): [ParamsApi, null] => {
  const { studentId, klassId, date } = params;

  return [{
    student_id: parseInt(studentId, 10),
    klass_id: parseInt(klassId, 10),
    date: date.getString(dateFormatApi),
  }, null];
};

export const convertResult = (res: ResultApi): AverageMarks => {
  const { result, ...marks } = res;
  const marksAverage = map(toFixedValue, marks);
  return marksAverage;
};

export const GET_GRADES_AVERAGE: Request<
  Params,
  AverageMarks,
  void
> = [
  'cabinet/dnevnik/grades/average',
  'get',
  ['data'],
];
